module.exports = {
  type: 'attachments',
  id: 'scans',
  icon: 'far fa-folder-upload',
  title: {
    de: 'Weitere Daten',
    en: 'Additional data'
  },
  introOff: {
    style: 'info',
    icon: 'fas fa-info',
    de: 'Wenn die Option "Ich möchte analoge Modelle versenden" gewählt wurde, wird kein Upload benötigt',
    en: 'No upload is required if you select option "analog model"'
  },
  form: [{
    id: 'modelType',
    type: 'radio',
    required: true,
    requires: {
      $neq: {
        model: 'none'
      }
    },
    label: {
      de: 'Wenn die Option "Ich möchte analoge Modelle versenden" gewählt wurde, wird kein Upload benötigt',
      en: 'No upload is required if you select option "analog model"'
    },
    defaultValue: 'digital',
    options: [{
        value: 'digital',
        label: {
          de: 'Ich möchte <b>digitale Modelldaten</b> versenden',
          en: 'I want to send <b>digital models</b>'
        },
        info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        }
      },
      {
        value: 'analog',
        label: {
          de: 'Ich möchte <b>analoge Modelle</b> versenden',
          en: 'I want to send <b>analog models</b>'
        },
        info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        }
      }
    ]
  }, ],

  // Global settings and restrictions
  fileTypes: null, // Everything is permitted
  sizeLimit: null, // Size limit in MB
  fileLimit: null, // No upload limit
  height: 150,

  classes: {
    modelScan: {
      fileTypes: ['.stl', '.zip', '.obj', '.ply', '.7z'],
      fileLimit: 1,
      requires: 1,
      secure: true,
      compact: true,
      imageUrl: '/img/scans/jaw.jpg',
      placeholderColor: '#10c1b0',
      background: '#fff',
      showIf: {
        modelType: 'digital',
        $neq: {
          model: 'none'
        }
      },
      title: {
        de: 'Kieferscan',
        en: 'Jaw'
      },
      placeholder_OFF: {
        de: 'Kieferscan',
        en: 'Jaw'
      }
    },
    antagonistScan: {
      fileTypes: ['.stl', '.zip', '.obj', '.ply', '.7z'],
      fileLimit: 1,
      requires: 1,
      secure: true,
      compact: true,
      imageUrl: '/img/scans/antagonist.jpg',
      placeholderColor: '#10c1b0',
      background: '#fff',
      showIf: {
        modelType: 'digital',
        $neq: {
          model: 'none'
        }
      },
      title: {
        de: 'Gegenkieferscan',
        en: 'Antagonist scan'
      },
      placeholder_OFF: {
        de: 'Gegenkieferscan',
        en: 'Antagonist scan'
      }
    },
    biteScan: {
      fileTypes: ['.stl', '.zip', '.obj', '.ply', '.7z'],
      fileLimit: 1,
      requires: 0, // Optional
      secure: true,
      compact: true,
      imageUrl: '/img/scans/bite.jpg',
      placeholderColor: '#10c1b0',
      background: '#fff',
      showIf: {
        modelType: 'digital',
        $neq: {
          model: 'none'
        }
      },
      title: {
        de: 'Biss-/Vestibulärscan',
        en: 'Bite/vestibular scan'
      },
      placeholder_OFF: {
        de: 'Biss-/Vestibulärscan',
        en: 'Bite/vestibular scan'
      }
    },
    attachment: {
      title: {
        de: 'Anhänge',
        en: 'Attachments'
      },
      sizeLimit: null,
      fileLimit: null,
      imageUrl: '/img/scans/situ.jpg',
      placeholderColor: '#10c1b0',
      background: '#fff',
      placeholder: {
        de: 'Hier können Sie weitere Dateien hochladen (z.B. Photos, Planungsdaten, etc.)',
        en: 'Here you can upload additional files, e.g. photos, plans, etc.'
      },
    }
  }
}
